function getFullUrl(suffix) {
  if (!window.OPSEEKER_CONFIG) return null;
  return getUrlWithFallback(suffix, window.OPSEEKER_CONFIG.CDN_URL + suffix);
}

function getUrlWithFallback(suffix, localFallback) {
  return window.location.origin.includes("localhost:") && localFallback ? localFallback : window.location.origin + suffix;
}

export var MEDIA_URL = getFullUrl("/media");
export var LOTTO_URL = getFullUrl("/conf/lotto-terms-conditions.html");